export const regExp = {
  ssn: /^(?!000)[0-9]{3}([ -]?)(?!00)[0-9]{2}\1(?!0000)[0-9]{4}$/,
  phone: /^$|^\(?([2-9][0-8][0-9])\)?[\s-]?([2-9][0-9]{2})[\s-]?([0-9]{4})$/,
  phoneStrict: /^\(?([2-9]\d{2})\)?[\s-]?(\d{3})[\s-]?(\d{4})$/,
  email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  zipCode: /^\d{5}$/,
}
